<script>
	// Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Vitrine		from '../components/Vitrine.svelte'

   	// Code	
	let titlePage = 'Faça uma Cotação Online | Seguros ';

	let cotacoes = [
		{
			icon: 'fas fa-couch fa-3x',
			title: 'Conteúdo',
			link: '/seguro-conteudo'
		},
		{
			icon: 'fas fa-plane fa-3x',
			title: 'Viagem',
			link: 'https://wwws.portoseguro.com.br/vendaonline/viagem/home.ns?cod=5ff4c3d3cdd545e8b5ca8cae3d589479<https://wwws.portoseguro.com.br/vendaonline/viagem/home.ns?cod=5ff4c3d3cdd545e8b5ca8cae3d589479&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS>&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS'
		},
		{
			icon: 'fas fa-mobile fa-3x',
			title: 'Equipamentos Portáteis',
			link: 'https://wwws.portoseguro.com.br/vendaonline/equipamentosportateis/home.ns?cod=6ab8a980bdff4fe9a93e578aeb31e542<https://wwws.portoseguro.com.br/vendaonline/equipamentosportateis/home.ns?cod=6ab8a980bdff4fe9a93e578aeb31e542&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS>&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS'
		},
		{
			icon: 'fas fa-heart fa-3x',
			title: 'Vida Mais Simples',
			link: 'https://wwws.portoseguro.com.br/vendaonline/vidamaissimples/home.ns?cod=234fb982da8b42218191b694415c93c3<https://wwws.portoseguro.com.br/vendaonline/vidamaissimples/home.ns?cod=234fb982da8b42218191b694415c93c3&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS>&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS'
		},
		{
			icon: 'fas fa-car fa-3x',
			title: 'Automóvel',
			link: 'https://wwws.portoseguro.com.br/vendaonline/equipamentosportateis/home.ns?cod=6ab8a980bdff4fe9a93e578aeb31e542<https://wwws.portoseguro.com.br/vendaonline/equipamentosportateis/home.ns?cod=6ab8a980bdff4fe9a93e578aeb31e542&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS>&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS'
		},
		{
			icon: 'fas fa-home fa-3x',
			title: 'Residência',
			link: 'https://wwws.portoseguro.com.br/vendaonline/residencia/home.ns?cod=18083ccde79a4672bde40d06d0a3139e<https://wwws.portoseguro.com.br/vendaonline/residencia/home.ns?cod=18083ccde79a4672bde40d06d0a3139e&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS>&utm_source=58862J&utm_medium=geradorLinks&utm_campaign=GeradordeLinks_CMD79J&utm_content=RFS_CORRETORA_DE_SEGUROS'
		},
	];
</script>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p class="mt-20">A Freire Imóveis disponibiliza diversos tipos de seguros com cotação online. Escolha nas opções abaixo:</p>
		</div>
	</div>
</PageHeader>

<div class="container clearfix">
	<div class="flex flex-wrap gap-20">
		{#each cotacoes as item, i}
		<div class="item flex-1 background-gray round-all pa-20 text-center flex flex-column gap-15">
			<div class="icon">
				<i class="{item.icon} color-secondary"></i> 
			</div>
			<p class="p-0 m-0 text-bold flex flex-center" style="min-height: 55px">{item.title}</p>
			<a class="btn btn-primary" target="_blank" href="{item.link}"><i class="far fa-calculator"></i> Cotação Online</a>
		</div>
		{/each}
	</div>
</div>